import { render, staticRenderFns } from "./shelfTaskGoodsDetail.vue?vue&type=template&id=386b3b8e&scoped=true&"
import script from "./shelfTaskGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./shelfTaskGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./shelfTaskGoodsDetail.vue?vue&type=style&index=0&id=386b3b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3b8e",
  null
  
)

export default component.exports